import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import "./styles.scss";
import "./mobile.scss";
import {
  Button,
  ButtonIcon,
  DetailsCard,
  InfoCard,
  Input,
} from "../../../../components";
import {
  RiArrowRightLine,
  RiFacebookFill,
  RiInstagramLine,
  RiTiktokFill,
  RiYoutubeLine,
} from "react-icons/ri";
import { GetIcon } from "../../../../config/icon";
import { GetMessageText, StringRegex, validateNumber } from "../../../../utils";
import { Select, Space } from "antd";
import Footer from "../../../Footer";

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isSuccess: false,
      wizardNo: 1,
      userId: null,
      tags: [],
      tag: null,
      otp: null,
      token: null,
      attempt: 0,
      termsAndCondition: true,
      formIsValid: false,
      viewPointWidth: 0,
      viewPointHeight: 0,
      displayOtpResend: false,
      isEnableLoginIn: false,
      isExistingUser: false,
      isFoundUser: false,
      formHeader: "Sign up",
      userType: 1,
      isLogo: true,
      timer: "00:00",
      userData: null,
      registeredType: 1,
      wizardStep: 1,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  updateWindowDimensions() {
    this.setState({
      viewPointWidth: window.innerWidth,
      viewPointHeight: window.innerHeight,
    });
  }

  handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
    console.log("scrollTop : " + scrollTop);
    console.log("scrollHeight : " + scrollHeight);
    console.log("clientHeight :" + clientHeight);
  };

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    window.addEventListener("scroll", this.handleOnScroll);
    // this.props.getAllRecentTransfers();
    //this.props.getAllFavouritesTransfers();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleOnScroll);
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  render() {
    const { viewPointHeight, isLoading, dataForm } = this.state;
    const { isMoreInfo, onClick } = this.props;

    return (
      <>
        {/* <div className={"mim__header"}>
          <div className={"container"}>
            <div className={"d-flex flex-row"}>
              <ButtonIcon
                type={"back"}
                onClick={() => this.props.history.push("/")}
                size={"lg-x"}
                buttonIcon={GetIcon("leftArrow")}
              />

              <div className={"mimh__title"}>Privacy Policy </div>
            </div>
          </div>
        </div> */}
        {/* privacy-policy */}
        <div className={"mim__privacy"}>
          <div className={"mimp__top-wrapper"}>
            <div className={"mimp__tw-title"}>{"Last Update : [Date]"}</div>
            <div className={"mimp__tw-content flex-wrap"}>
              <span className={"mimp__mail"}>creditcardoffers.lk</span>
              {
                "is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website"
              }
              <span className={"mimp__web"}>https://creditcardoffers.lk</span>
              {
                ", including any other media form, media channel, mobile website, or mobile application related or connected thereto (collectively, the “Site”). Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, please do not access the site."
              }
            </div>
          </div>
          <DetailsCard
            no={"1."}
            title={" Information We Collect"}
            content={""}
            subContentList={[
              {
                subContentTitle: "Personal Data",
                subContent:
                  "We may collect personally identifiable information, such as your name, email address, and mobile number, that you voluntarily provide to us when you register with the Site or when you choose to participate in various activities related to the Site, such as online chat and message boards",
              },
              {
                subContentTitle: "Derivative Data",
                subContent:
                  "nformation our servers automatically collect when you access the Site, such as your IP address, your browser type, your operating system, your access times, and the pages you have viewed directly before and after accessing the Site",
              },
              {
                subContentTitle: "Financial Data",
                subContent:
                  "We do not collect or store any financial information. All credit card offer information is sourced from related bank websites and does not involve direct financial transactions on our Site.",
              },
              {
                subContentTitle: "Mobile Device Data",
                subContent:
                  "Device information, such as your mobile device ID, model, and manufacturer, and information about the location of your device if you access the Site from a mobile device.",
              },
            ]}
          />
          <DetailsCard
            no={"2."}
            title={" Use of Your Information"}
            content={
              "Having accurate information about you permits us to provide you with a smooth, efficient, and customized experience. Specifically, we may use information collected about you via the Site to:"
            }
            subList={[
              { listContent: "Create and manage your account." },
              {
                listContent:
                  "Compile anonymous statistical data and analysis for use internally or with third parties.",
              },
              {
                listContent:
                  "Deliver targeted advertising, coupons, newsletters, and other information regarding promotions and the Site to you.",
              },
              {
                listContent: "Email you regarding your account or order.",
              },
              {
                listContent: "Enable user-to-user communications.",
              },
              {
                listContent:
                  "Fulfill and manage purchases, orders, payments, and other transactions related to the Site.",
              },
              {
                listContent:
                  "Increase the efficiency and operation of the Site.",
              },
              {
                listContent:
                  "Monitor and analyze usage and trends to improve your experience with the Site.",
              },
              {
                listContent: "Notify you of updates to the Site.",
              },
              {
                listContent:
                  "Offer new products, services, and/or recommendations to you.",
              },
              {
                listContent: "Perform other business activities as needed.",
              },
              {
                listContent:
                  "Prevent fraudulent transactions, monitor against theft, and protect against criminal activity.",
              },
              {
                listContent: "Process payments and refunds.",
              },
              {
                listContent:
                  "Request feedback and contact you about your use of the Site.",
              },
              {
                listContent: "Resolve disputes and troubleshoot problems.",
              },
              {
                listContent:
                  "Respond to product and customer service requests.",
              },
              {
                listContent: "Send you a newsletter.",
              },

              {
                listContent: "Solicit support for the Site.",
              },
            ]}
          />
          <DetailsCard
            no={"3."}
            title={" Disclosure of Your Information"}
            content={
              "We may share information we have collected about you in certain situations. Your information may be disclosed as follows:"
            }
            subContentList={[
              {
                subContentTitle: "By Law or to Protect Rights",
                subContent:
                  "If we believe the release of information about you is necessary to respond to legal process, to investigate or remedy potential violations of our policies, or to protect the rights, property, and safety of others, we may share your information as permitted or required by any applicable law, rule, or regulation.",
              },
              {
                subContentTitle: "Third-Party Service Providers",
                subContent:
                  "We may share your information with third parties that perform services for us or on our behalf, including payment processing, data analysis, email delivery, hosting services, customer service, and marketing assistance.",
              },
              {
                subContentTitle: "Marketing Communications",
                subContent:
                  "With your consent, or with an opportunity for you to withdraw consent, we may share your information with third parties for marketing purposes, as permitted by law.",
              },
              {
                subContentTitle: "Interactions with Other Users",
                subContent:
                  "If you interact with other users of the Site, those users may see your name, profile photo, and descriptions of your activity, including sending invitations to other users, chatting with other users, liking posts, and following blogs",
              },
              {
                subContentTitle: "Third-Party Advertisers",
                subContent:
                  "We may use third-party advertising companies to serve ads when you visit the Site. These companies may use information about your visits to the Site and other websites that are contained in web cookies to provide advertisements about goods and services of interest to you.",
              },
              {
                subContentTitle: "Affiliates",
                subContent:
                  "We may share your information with our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include our parent company and any subsidiaries, joint venture partners, or other companies that we control or that are under common control with us.",
              },
            ]}
          />
          <DetailsCard
            no={"4."}
            title={" Security of Your Information"}
            content={
              "We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable, and no method of data transmission can be guaranteed against any interception or other types of misuse."
            }
          />
          <DetailsCard
            no={"4."}
            title={" Security of Your Information"}
            content={
              "We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable, and no method of data transmission can be guaranteed against any interception or other types of misuse."
            }
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(Index);
